import { generalAxiosInstance } from "../axios/axiosConfig";

export async function PriceValues() {
  try {
    const response = await generalAxiosInstance.get("/PriceValues");
    return response.data;
  } catch (error) {
    return error.response?.data || "An error occurred";
  }
}
